const lastOr = <T>(valueIfNone: T) => (list: T[]): T => {
  return list[list.length - 1] ?? valueIfNone
}

export { lastOr }
